import { initialsOf } from '../lib/time.js';

import type { ReactElement } from 'react';

type AvatarProps = {
  readonly displayName: string;
  readonly avatarUrl?: string | null;
};

export const Avatar = ({ displayName, avatarUrl }: AvatarProps): ReactElement => {
  if (avatarUrl !== undefined && avatarUrl !== null) {
    return (
      <img
        src={avatarUrl}
        alt=""
        className="ring-subtle size-10 shrink-0 rounded-pill object-cover ring-1"
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      className="bg-accent-subtle text-brand-text ring-subtle grid size-10 shrink-0 place-items-center rounded-pill text-sm font-semibold ring-1"
    >
      {initialsOf(displayName)}
    </div>
  );
};
